/*!

=========================================================
* Black Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useContext} from "react";
import { useHistory } from "react-router-dom";
import { UserLoginContext } from "../../context/UserLoginContext";
import { QuestionsContext } from "../../context/QuestionsContext";
import { CollectionsContext } from "../../context/CollectionsContext";
// nodejs library that concatenates classes
import classnames from "classnames";

//import PropTypes from "prop-types";
//import { bindActionCreators } from 'redux';
//import {connect, useDispatch, useSelector} from 'react-redux';
//import * as loginActions from '../../actions/loginActions';
import SweetAlert from 'react-bootstrap-sweetalert';
import NotificationAlert from "react-notification-alert";
import rest from '../../API/api';
import authService from '../../services/authService';


// reactstrap components
import {
  Button,
  Card,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  InputGroup,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  UncontrolledTooltip, CardHeader, CardTitle, CardBody, InputGroupAddon, InputGroupText, CardFooter, Form,FormGroup,
} from "reactstrap";
import {EventsContext} from "../../context/EventsContext";

const AdminNavbar = (props) => {
  const history = useHistory();
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [modalLogin, setModalLogin] = React.useState(false);
  const [color, setColor] = React.useState("navbar-transparent");
  const [state, setState] = useContext(UserLoginContext);
  const [questionsState, setQuestionsState] = useContext(QuestionsContext);
  const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
  const [eventsState, setEventsState] = useContext(EventsContext);

  const [UserIDFocus, setUserIDFocus] = React.useState(false);
  const [passwordFocus, setPasswordFocus] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [alert,setAlert] = React.useState(null);
  const [isLoggingIn, setIsLoggingIn] = React.useState(false);

  // Refs for Enter key navigation
  const emailInputRef = React.useRef(null);
  const passwordInputRef = React.useRef(null);
  const notificationAlertRef = React.useRef(null);

  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    //debugger;
    //console.log("User Status after initialization:" + userLoggedIn[0].status);
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };

  },[]);

  const notify = (type, message, duration = 7) => {
    const options = {
      place: "tc",
      message: (
        <div>
          <div>{message}</div>
        </div>
      ),
      type: type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: duration,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  function successAlert(authenticated){
    //Setup the alert and use the context to route to the home page once logged in.
    if(authenticated) {
      notify("success", "You have been logged in!", 2);
      toggleModalLogin();

      // Auto-dismiss after 2 seconds and redirect to dashboard
      setTimeout(() => {
        history.push("/admin/dashboard");
      }, 2000);
    }
    else
    {
      notify("danger", "Invalid Username or Password, please try again!", 3);
      setTimeout(() => {
        emailInputRef.current?.focus();
      }, 100);
      setState(state => ({...state, status: false }));
    }
  }

  function hideAlert() {
    setAlert(null);
  };

  function logoutAlert() {
    //console.log("calling sweet alert")
    notify("success", "You have been logged out!", 2);
    //debugger;
    setTimeout(() => {
      history.push("/dashboard");
    }, 2000);
  }

  //Log user out
  function logUserOut(e) {
    e.preventDefault();

    // Redirect to dashboard immediately to prevent flash of login page
    history.push("/admin/dashboard");

    // Clear JWT token and user data from localStorage
    authService.logout();

    //lets clear the user information state
    setState({
      Userid: "",
      Email: "",
      Fname: "",
      Lname: "",
      status: false,
      role: "",
      _id: "",
      token: "",
      cloudinary_upload: "",
      cloudinary_destory: "",
      apiKeyCloudinary: "",
      apiSecretKeyCloudinary: "",
      apiKey: ""
    });

    //Clear the Questions Context
    setQuestionsState((questionsState) => ({
      ...questionsState,
      theQuestions: [
        {
          _id: "Loading...",
          Title: "Loading...",
          Question: "Loading...",
          Type: "Loading...",
          Value: "Loading...",
          PlaceHolder: "Loading..."
        }
      ]
    }));

    // Clear Collections Context
    setCollectionsState((collectionsState) => ({
      ...collectionsState,
      cohortCollections: [],
      tourneyCollections: [],
      generalCollections: []
    }));

    logoutAlert();
  }

  //Log user in with JWT Authentication
  const logUserIn = async (e) => {
    if (e) e.preventDefault();

    // Prevent multiple simultaneous login attempts
    if (isLoggingIn) return;
    setIsLoggingIn(true);

    try {
      // Get form values (using email for the new API)
      const email = (document.getElementById('email')?.value || document.getElementById('username')?.value)?.trim();
      const password = document.getElementById('password')?.value?.trim();

      if (!email || !password) {
        notify("danger", "Please enter both email and password", 3);
        setTimeout(() => {
          emailInputRef.current?.focus();
        }, 100);
        setIsLoggingIn(false);
        return;
      }

      // Call JWT login service
      const result = await authService.login(email, password);

      if (!result.success) {
        successAlert(false);
        setIsLoggingIn(false);
        return;
      }

      const loginResult = result.user;

      // Update user state with JWT token and user data
      setState(state => ({...state, status: true }));
      setState(state => ({...state, token: result.token }));
      setState(state => ({...state, role: loginResult.role || loginResult.Role || 'User' }));
      setState(state => ({...state, Userid: loginResult.Userid || loginResult.userId || loginResult._id }));
      setState(state => ({...state, Email: loginResult.Email || loginResult.email }));
      setState(state => ({...state, Fname: loginResult.Fname || loginResult.firstName || '' }));
      setState(state => ({...state, Lname: loginResult.Lname || loginResult.lastName || '' }));
      setState(state => ({...state, _id: loginResult._id || loginResult.userId }));

      // Legacy fields (if still needed by other parts of the app)
      setState(state => ({...state, cloudinary_upload: loginResult.cloudinary_upload || '' }));
      setState(state => ({...state, cloudinary_destory: loginResult.cloudinary_destory || '' }));
      setState(state => ({...state, apiKeyCloudinary: loginResult.apiKeyCloudinary || '' }));
      setState(state => ({...state, apiSecretKeyCloudinary: loginResult.apiSecretKeyCloudinary || '' }));
      setState(state => ({...state, apiKey: rest.apiKey }));

      // Try to load data from API endpoints (may not exist)
      try {
        //Lets load the Questions Context from the DB
        const questionsList = await authService.authenticatedFetch(rest.questions, {
          method: 'GET'
        });
        if (questionsList.ok) {
          const questionsData = await questionsList.json();
          setQuestionsState((questionsState) => ({
            ...questionsState,
            theQuestions: questionsData
          }));
        }
      } catch (error) {
        console.log('Could not load questions:', error.message);
      }

      try {
        //Lets load all the Collections for cohort, tourney and general
        //Images will be loaded when I click the edit the collection images
        const cohortCollectionsList = await authService.authenticatedFetch(rest.cohortCollections, {
          method: 'GET'
        });
        if (cohortCollectionsList.ok) {
          const cohortCollectionsData = await cohortCollectionsList.json();
          setCollectionsState((collectionsState) => ({
            ...collectionsState,
            cohortCollections: cohortCollectionsData
          }));
        }
      } catch (error) {
        console.log('Could not load cohort collections:', error.message);
      }

      try {
        const tourneyCollectionsList = await authService.authenticatedFetch(rest.tourneyCollections, {
          method: 'GET'
        });
        if (tourneyCollectionsList.ok) {
          const tourneyCollectionsData = await tourneyCollectionsList.json();
          setCollectionsState((collectionsState) => ({
            ...collectionsState,
            tourneyCollections: tourneyCollectionsData
          }));
        }
      } catch (error) {
        console.log('Could not load tourney collections:', error.message);
      }

      try {
        const generalCollectionsList = await authService.authenticatedFetch(rest.generalCollections, {
          method: 'GET'
        });
        if (generalCollectionsList.ok) {
          const generalCollectionsData = await generalCollectionsList.json();
          setCollectionsState((collectionsState) => ({
            ...collectionsState,
            generalCollections: generalCollectionsData
          }));
        }
      } catch (error) {
        console.log('Could not load general collections:', error.message);
      }

      successAlert(true);

      // Navigate to dashboard after successful login
      setTimeout(() => {
        history.push('/admin/dashboard');
      }, 2000); // Wait for success alert to show

      setIsLoggingIn(false);
    } catch (error) {
      console.error('Login error:', error);
      successAlert(false);
      setIsLoggingIn(false);
    }
  };

  // function that adds color white/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
  };
  // this function opens and closes the collapse on small devices
  const toggleCollapse = () => {
    if (collapseOpen) {
      setColor("navbar-transparent");
    } else {
      setColor("bg-white");
    }
    setCollapseOpen(!collapseOpen);
  };
  // this function is to open the Login modal
  const toggleModalLogin = () => {
    setModalLogin(!modalLogin);
  };
  //debugger;
  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Navbar
        className={classnames("navbar-absolute", {
          [color]: props.location.pathname.indexOf("full-screen-map") === -1,
        })}
        expand="lg"
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize d-inline">
              <Button
                className="minimize-sidebar btn-just-icon"
                color="link"
                id="tooltip209599"
                onClick={props.handleMiniClick}
              >
                <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
              </Button>
              <UncontrolledTooltip
                delay={0}
                target="tooltip209599"
                placement="right"
              >
                Sidebar toggle
              </UncontrolledTooltip>
            </div>


            <div
              className={classnames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <button
                className="navbar-toggler"
                type="button"
                onClick={props.toggleSidebar}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
              {props.brandText}
            </NavbarBrand>
          </div>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navigation"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto" navbar>
                <li style={{ backgroundColor: 'transparent' }}>
                  {state.status ? (
                          <Button
                              className="btn-round"
                              color="default"
                              data-target="#loginModal"
                              data-toggle="modal"
                              onClick={logUserOut}
                          >
                            <i className="tim-icons icon-lock-circle"/>
                            Logout

                          </Button>)
                      :
                      (<Button
                          className="btn-round"
                          color="default"
                          data-target="#loginModal"
                          data-toggle="modal"
                          onClick={toggleModalLogin}
                      >
                        <i className="tim-icons icon-lock-circle"/>
                        Login

                      </Button>)
                  }
                  {alert}
                </li>
              {/*
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                >
                  <div className="notification d-none d-lg-block d-xl-block" />
                  <i className="tim-icons icon-sound-wave" />
                  <p className="d-lg-none">Notifications</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">
                      Mike John responded to your email
                    </DropdownItem>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">
                      You have 5 more tasks
                    </DropdownItem>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">
                      Your friend Michael is in town
                    </DropdownItem>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">
                      Another notification
                    </DropdownItem>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">
                      Another one
                    </DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              */}

              {/*
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    <img
                      alt="..."
                      src={require("assets/img/TheDeepSharksLogo.jpg").default}
                    />
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                  <p className="d-lg-none">Log out</p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">

                  <NavLink tag="li">
                    <DropdownItem className="nav-item">Profile</DropdownItem>
                  </NavLink>
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">Settings</DropdownItem>
                  </NavLink>
                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                    <DropdownItem className="nav-item">Log in</DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              */}
              <li className="separator d-lg-none" />
            </Nav>

          </Collapse>
        </Container>
      </Navbar>
      <Modal
      className="modal-login"
      modalClassName="modal-info"
      isOpen={modalLogin}
      toggle={toggleModalLogin}
      >
      <Card className="card-login card-plain">
        <div className="modal-header justify-content-center">
          <button
              aria-hidden={true}
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={toggleModalLogin}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
          <div className="header header-primary text-center">
            <div className="modal-profile">
              <i className="tim-icons icon-badge" />
            </div>
          </div>
        </div>
        <div className="modal-body">
        <FormGroup>
            <div className="card-content">
              <InputGroup
                  className={classnames("no-border form-control-lg", {
                    "input-group-focus": {UserIDFocus}
                  })}
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="tim-icons icon-single-02" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                    placeholder="Email..."
                    type="email"
                    id="email"
                    innerRef={emailInputRef}
                    onFocus={e => (setUserIDFocus(true))}
                    onBlur={e => (setUserIDFocus(false))}
                    onKeyPress={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        passwordInputRef.current?.focus();
                      }
                    }}
                />
              </InputGroup>
              <InputGroup
                  className={classnames("no-border form-control-lg", {
                    "input-group-focus": {passwordFocus}
                  })}
              >
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="tim-icons icon-key-25" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                    placeholder="Password..."
                    type={showPassword ? "text" : "password"}
                    id="password"
                    innerRef={passwordInputRef}
                    onFocus={e => (setPasswordFocus(true))}
                    onBlur={e => (setPasswordFocus(false))}
                    onKeyPress={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        logUserIn();
                      }
                    }}
                />
                <InputGroupAddon addonType="append">
                  <InputGroupText
                    style={{ cursor: 'pointer' }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}></i>
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </div>
        </FormGroup>
        </div>
        <div className="modal-footer text-center pt-4">
          <Button
              block
              className="btn-neutral btn-round"
              href="#pablo"
              onClick={logUserIn}
              size="lg"
              color="info"
          >
            Login
          </Button>
        </div>
      </Card>

    </Modal>
      {alert}
    </>
  );
};
/*

function mapStateToProps(state, ownProps) {
  debugger;
  return {
    userLoggedIn: state.userLoggedIn
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch)
  };
}
*/

//export default connect(mapStateToProps, mapDispatchToProps)(AdminNavbar);
export default AdminNavbar;
